export default __webpack_public_path__ + "static/media/reviewer-2.52e03342.png";